import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, Layout } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import { history } from 'Store';
import { pathNameSelector } from 'Store/modules/router/selectors';
import useTranslation from 'Hooks/useTranslation';
import { useFetchGetFeatureFlagRecord } from 'Containers/Datagathering/hooks';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { TAX_YEAR } from 'Config';
import { routes } from 'Constants/routes';
import { iconsPaths } from 'Constants/iconsPath';
import * as Styled from './styles';
import { entertraimentActions } from './utils';
import Progress from './ProgressBar';

const TIME_OUT_MILLISECOND = 180000;

const DataGatheringLoaderXml = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const [userTime, setUserTime] = useState(0);
  const [type, setType] = useState('result');
  const pathname = useSelector(pathNameSelector);
  useFetchGetFeatureFlagRecord();

  useEffect(() => {
    let timer;
    if (pathname === routes.DATAGATHERING_LOADER) {
      EventService.taxDataUserTime(TAX_YEAR, userTime);
      timer = setTimeout(() => {
        setType(entertraimentActions[type].nexType);
        setUserTime(prev => prev + entertraimentActions[type].progress);
      }, 10000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [pathname, type, userTime]);

  useEffect(() => {
    const timer = setTimeout(() => {
      EventService.taxDataWaitTimeOut(TAX_YEAR, TIME_OUT_MILLISECOND);
      history.push(routes.DATAGATHERING_SAT_ERROR);
    }, TIME_OUT_MILLISECOND);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <OneColLayout>
      <Layout.Grid
        alignContent="center"
        alignItems="center"
        columns="repeat(1, 1fr)"
        gap="dimension_08"
        justifyContent="center"
        justifyItems="center"
      >
        <Styled.Container direction="column" align="center" justify="center">
          <img src={iconsPaths.TAX} alt="taxito" />
          <Text
            type="headline"
            color="dark"
            align="center"
            size="XS_L_S"
            mb="fds_size_48"
            mt="fds_size_32"
          >
            {t(entertraimentActions[type].title)}
          </Text>
          <Text type="paragraphs" color="dark" align="center" size="S_S_S" mb="fds_size_24">
            {t(entertraimentActions[type].subtitle)}
          </Text>
          <Progress />
        </Styled.Container>
      </Layout.Grid>
    </OneColLayout>
  );
};

export default DataGatheringLoaderXml;
